// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"d616b1e7","20":"4f5312a2","284":"e3caf3f2","417":"bfd9d37a","551":"f7d15f58","682":"f5946e72","738":"fd26a512","760":"1e1ea70c","799":"84971528","809":"4881062b","841":"0b88d731","857":"1673adc5","903":"ae79d9ca","904":"9571d734","921":"e726df4b","960":"69e7bedc"}[chunkId] + ".chunk.js";
};